//#region Libraries
import { Row } from "components/styles";
import styled from "styled-components";
//#endregion

export const Container = styled(Row)`
    gap: 7px;
    & span:first-child {
        font-weight: bold;
        font-size: 12px;
    }
`;
export const Circle = styled.span`
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: ${(({ color }) => color)};
    border: 1px solid ${({ borderColor, color }) => borderColor ? borderColor : color};
`;